import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChargingStation, FaHeadphones, FaHeadset, FaUsb, FaBatteryFull, FaMobileAlt, FaClock, FaMobile, FaGooglePlay, FaApple } from 'react-icons/fa';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../../config/firebase';
import ProductCard from './accessories/ProductCard';
import ServiceCard from './services/ServiceCard';

export default function HomePage() {


  const categories = [
    { name: 'Chargers', icon: <FaChargingStation className="text-4xl text-bright-green mb-3" /> },
    { name: 'Ear Buds', icon: <FaHeadphones className="text-4xl text-bright-green mb-3" /> },
    { name: 'Hands Free', icon: <FaHeadset className="text-4xl text-bright-green mb-3" /> },
    { name: 'Data Cables', icon: <FaUsb className="text-4xl text-bright-green mb-3" /> },
    { name: 'Power Banks', icon: <FaBatteryFull className="text-4xl text-bright-green mb-3" /> },
    { name: 'Mobile Holders', icon: <FaMobileAlt className="text-4xl text-bright-green mb-3" /> },
    { name: 'Smart Watches', icon: <FaClock className="text-4xl text-bright-green mb-3" /> },
    { name: 'Back Covers', icon: <FaMobile className="text-4xl text-bright-green mb-3" /> },
  ];
  // const reviews = [
  //   "Best accessories at the best prices. Fast delivery too!",
  //   "The quality is top-notch. Love the app experience.",
  //   "Highly recommend Accessify for mobile accessories.",
  //   "Superb customer service and great packaging.",
  //   "Best online shopping experience I've had in a while.",
  //   "Wide variety, affordable prices, and quick delivery."
  // ];

  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [popularServices, setPopularServices] = useState([]);


  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        // Query Firestore collection
        const featuredProductsQuery = query(
          collection(db, 'products'), // 'products' is your collection name
          where("isFeatured", "==", true),
          limit(8)
        );

        // Fetch products
        const featuredProductsSnapshot = await getDocs(featuredProductsQuery);

        // Map snapshot to array of product data
        const featuredProductsList = featuredProductsSnapshot.docs.map(doc => ({
          ...doc.data()
        }));

        // Update state with Featured products
        setFeaturedProducts(featuredProductsList);
      } catch (error) {
        console.log('Error fetching Featured products: ', error);
        console.log(error.message);
      }
    };

     const fetchPopularServices = async () => {
      try {
        // Query Firestore collection
        const popularServicesQuery = query(
          collection(db, 'services'), // 'products' is your collection name
          where("isFeatured", "==", true),
          limit(8)
        );

        // Fetch products
        const popularServicesSnapshot = await getDocs(popularServicesQuery);

        // Map snapshot to array of product data
        const popularServicesList = popularServicesSnapshot.docs.map(doc => ({
          ...doc.data()
        }));

        // Update state with top-selling products
        setPopularServices(popularServicesList);
      } catch (error) {
        console.log('Error fetching top-selling products: ', error);
        console.log(error.message);
      }
    };



    const fetchData = async () => {
      try {
        await Promise.all([
          fetchFeaturedProducts(),
          fetchPopularServices(),
        ]);
      } catch (error) {
        console.log('Error fetching products: ', error);
      }
    };

    // Call the function to fetch products when component mounts
    fetchData();
  }, []); // Empty dependency array to run once on mount

  return (
    <div>
      {/* Hero Section */}
      <section className="mb-8 bg-gradient-to-r from-bright-green to-dark-green text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Welcome to Accessify
          </h1>
          <p className="text-lg md:text-xl mb-6">
            Your One-Stop Shop for Mobile Accessories
          </p>
          <Link
            to={'/store'}
            className="bg-bright-green text-white
                  font-semibold px-6 py-3 rounded-full shadow-md 
                  hover:bg-white hover:text-bright-green transition duration-300"
          >
            Shop Now
          </Link>
        </div>
      </section>


      {/* Get On App store and play store */}
      <section className="mb-8 bg-main-bg py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6 text-dark-text-color">
            Get the Accessify App
          </h2>
          <p className="text-lg mb-8 text-gray-600">
            Shop faster, track your orders, and get exclusive deals on our mobile app!
          </p>

          <div className="flex justify-center gap-4 flex-wrap">
            {/* Play Store */}
            <a
              href="https://play.google.com/store/apps/details?id=com.aurictech.accessify"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex items-center gap-4 bg-black text-white px-5 py-3 rounded-xl hover:bg-gray-900 transition-all duration-300">
                <FaGooglePlay className="text-3xl" />
                <div className="text-left">
                  <p className="text-xs">GET IT ON</p>
                  <h4 className="text-lg font-semibold">Play Store</h4>
                </div>
              </div>
            </a>
            {/* App Store */}
            <button
            // href=""
            // target="_blank"
            // rel="noopener noreferrer"
            >
              <div className="flex items-center gap-4 bg-black text-white px-5 py-3 rounded-xl hover:bg-gray-900 transition-all duration-300">
                <FaApple className="text-3xl" />
                <div className="text-left">
                  {/* <p className="text-xs">Download on the</p> */}
                  <p className="text-xs">Coming soon</p>
                  <h4 className="text-lg font-semibold">App Store</h4>
                </div>
              </div>
            </button>
          </div>
        </div>
      </section>



      {/* Featured Category Section */}
      <section className="mb-8 bg-main-bg">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-dark-text-color">Featured Categories</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {categories.map((category, index) => (
              <div key={index}
                className="p-4 text-white rounded-2xl shadow-md flex flex-col items-center">
                {category.icon}
                <h3 className="text-xl font-semibold mb-4 text-dark-text-color">{category.name}</h3>
                <Link
                  to="/store"
                  state={{ category: category.name }}
                  className="bg-bright-green text-white
                  font-semibold px-6 py-3 rounded-full shadow-md 
                  hover:bg-white hover:text-bright-green transition duration-300"
                >
                  View Products
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Top Selling Products */}
      {Array.isArray(featuredProducts) && featuredProducts.length > 0 &&
        <section className='mb-8 bg-main-bg'>
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-10 text-dark-text-color">🔥 Featured Products</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {featuredProducts.map((product) => (
                <ProductCard product={product} key={product.id} />
              ))}
            </div>
          </div>
        </section>
      }

      {/* Popular Services */}
      {Array.isArray(popularServices) && popularServices.length > 0 &&
        <section className='mb-8 bg-main-bg'>
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-10 text-dark-text-color">🔥 Popular Services</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {popularServices.map((service) => (
                <ServiceCard service={service} key={service.id} />
              ))}
            </div>
          </div>
        </section>
      }

      {/* Customers Section */}
      {/* <section className="mb-8 bg-main-bg py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-dark-text-color">
            What Our Customers Say
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow">
                <p>"{review}"</p>
              </div>
            ))}
          </div>

        </div>
      </section> */}


    </div>
  );
};
